import { ActionTypes, ContentTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";
import { simpleReducer } from "./utils";

const initialState = fromJS({
  projects: [],
  settings: [],
  pending: true,
  taskTypes: [],
  editMode: false,
  project: {
    favoriteTree: [],
    formSetting: {
      [ContentTypes.SALE]: {
        visibleFieldIds: [],
      },
      [ContentTypes.CONTACT]: {
        visibleFieldIds: [],
      },
      [ContentTypes.COMPANY]: {
        visibleFieldIds: [],
      },
      [ContentTypes.PRODUCT]: {
        visibleFieldIds: [],
      },
    },
    fields: [],
    types: [],
    members: [],
    projects: [],
    setup: true,
    currency: "USD",
    importStatus: false,
  },
  automationUsage: null,
  pendingAutomationUsage: false,
});

export const actions = {
  [ActionTypes.createProject]: simpleReducer("project", { editMode: false }),
  [ActionTypes.updateProject]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        importStatus: false,
        pending: false,
        project: payload,
        editMode: false,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.updateProjectField]: {
    next(state, { payload }) {
      const { fieldId, fieldValue } = payload;
      const newState = {
        ...state.toJS(),
        project: {
          ...state.get("project").toJS(),
          [fieldId]: fieldValue,
        },
        editMode: true,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getProject]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        project: payload,
        editingProject: payload,
        pending: false,
        editMode: false,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getProjects]: simpleReducer("projects", { editMode: false }),
  [ActionTypes.getMembers]: simpleReducer("members"),
  [ActionTypes.getFields]: simpleReducer("fields"),
  [ActionTypes.getFavoriteTree]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        project: {
          ...state.get("project").toJS(),
          favoriteTree: payload,
        },
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.updateFavoriteTree]: {
    next(state, { payload, pending }) {
      if (pending) {
        return state.merge({ pending });
      }
      const { favoriteTree } = payload;
      const newState = {
        ...state.toJS(),
        project: {
          ...state.get("project").toJS(),
          favoriteTree: favoriteTree,
        },
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getFormSetting]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const { formSetting, contentType } = payload;
      const newState = {
        ...state.toJS(),
        project: {
          ...state.get("project").toJS(),
          formSetting: {
            [contentType]: formSetting,
          },
        },
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.updateFormSetting]: {
    next(state, { payload, pending }) {
      if (pending) {
        return state.merge({ pending });
      }
      const { formSetting, contentType } = payload;
      const newState = {
        ...state.toJS(),
        project: {
          ...state.get("project").toJS(),
          formSetting: {
            [contentType]: formSetting,
          },
        },
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getWorkspaceAutomationUsage]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending, pendingAutomationUsage: false });
      }
      if (pending) {
        return state.merge({ pendingAutomationUsage: true });
      }
      return state.merge({
        automationUsage: payload ? fromJS(payload) : null,
        pendingAutomationUsage: false,
      });
    },
  },
  [ActionTypes.saveAIContentSetting]: {
    next(state, { payload, error }) {
      if (error) {
        return state.merge({
          error,
          pending: false,
        });
      }
      if (payload) {
        const currentProject = state.get("project");
        const aiSettings = payload?.data?.aiSetting || payload;
        const updatedProject = currentProject.set("aiSetting", fromJS(aiSettings));
        return state.set("project", updatedProject);
      }
      return state;
    },
  },

  [ActionTypes.updateAIContentSetting]: {
    next(state, { payload }) {
      if (payload) {
        const currentProject = state.get("project");
        const updatedProject = currentProject.set("aiSetting", fromJS(payload));
        return state.set("project", updatedProject);
      }
      return state;
    },
  },
};

export const projectReducer = handleActions(actions, initialState);
